import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  OnInit,
  Optional,
  Output,
  ViewChild
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { BRANDS_IDS, Vaki } from '@vaki/shared/util/interfaces';
import { filter } from 'rxjs/operators';
import { VakersVakisUiSupportFormComponent } from '@vaki/vakers/vakis/ui/support-form';

import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'lib-vakers-vakis-ui-free-contribution-box',
  imports: [MatCardModule, VakersVakisUiSupportFormComponent],
  templateUrl: './free-contribution-box.component.html',
  styleUrl: './free-contribution-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VakersVakisUiFreeContributionBoxComponent implements OnInit {
  @ViewChild(VakersVakisUiSupportFormComponent) vakiSupportFormComponent:
    | VakersVakisUiSupportFormComponent
    | undefined;
  @Input() vaki: Vaki | undefined;
  @Input() available = false;
  @Input() currencies: string[] | undefined | null;
  @Input() currentCurrency: string | undefined | null;
  @Output() currencyChange = new EventEmitter<string>();
  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: {
      vaki: Vaki | undefined;
      available: boolean;
      currencies: string[] | undefined | null;
      currentCurrency: string | undefined | null;
    },
    @Optional()
    private readonly matDialogRef: MatDialogRef<VakersVakisUiFreeContributionBoxComponent>,
    private readonly router: Router,
    @Inject(LOCALE_ID) private locale: string
  ) {
    if (data) {
      this.vaki = data.vaki;
      this.available = data.available;
      this.currencies = data.currencies;
      this.currentCurrency = data.currentCurrency;
    }
  }
  BRANDS_IDS = BRANDS_IDS;
  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((events) => {
        const eventsRouter = events as NavigationEnd;
        if (
          this.data &&
          eventsRouter.url.startsWith(`/checkout/${this.data.vaki?.key}`)
        ) {
          this.matDialogRef.close();
        }
      });
  }

  inputCurrencyChange(currency: string) {
    this.currencyChange.emit(currency);
  }

  freeSupportText(brand: string | undefined) {
    if (brand === BRANDS_IDS.SPONSOR) {
      return this.locale === 'en'
        ? 'Make a unique payment in cash, PSE or credit card'
        : 'Paga una única vez en efectivo, PSE o tarjeta de crédito';
    } else {
      return this.locale === 'en'
        ? 'Make a contribution of the value you want'
        : 'Realiza un aporte sin recompensa del valor que desees';
    }
  }
}
